import { createStore } from "vuex"

export default createStore({
  state: {
    params: {
      lang: "en",
      withLangs: false,
      domain: "https://plastinka.com",
      apiUrl: "https://plastinka.com/edit/new_api/",
      editorUrl: "https://evgenii-b-site-editor-e85d.twc1.net/",
      boxesQty: 70,
    },
    userSessionStarted: false,
    userRole: "",
    userId: 0,
    userRolePermissions: {
      root: {
        modules: true,
        reports: true,
        users: true,
        users_export: true,
      },

      upr: {
        reports: true,
        modules: true,
        orders: true,
        services: true,
        oracle: true,
        oracle_reports: true,
        pages: true,
      },

      mm: {
        modules: [
          "lp",
          "cd",
          "acc_products",
          "labels",
          "artists",
          "suppliers",
          "countries",
          "youtube",
          "lp_album_tails",
          "cd_album_tails",
        ],
        packs: ["50", "52"],
        reports: ["store_pickup", "full_cat"],
        orders: true,
      },

      zakaz: {
        modules: ["lp", "cd", "acc_products"],
        packs: ["50"],
        orders: true,
        reports: ["store_pickup"],
      },

      vit: {
        reports: ["sales", "full_cat"],
      },

      photo: {
        modules: [
          "lp",
          "cd",
          "acc_products",
          "labels",
          "artists",
          "suppliers",
          "youtube",
          "lp_album_tails",
          "cd_album_tails",
          "sales",
        ],
        packs: ["52", "50", "51"],
        reports: [
          "photo_lp",
          "lp_no_keys",
          "photo_1c_copies",
          "full_cat",
          "artists",
          "top_artists",
          "photo_lp",
          "lp_no_keys",
          "photo_1c_copies",
          "add_copies",
        ],
      },

      cat_manager: {
        modules: [
          "lp",
          "cd",
          "acc_products",
          "labels",
          "artists",
          "countries",
          "lp_comments",
          "sales",
          "styles",
        ],
        packs: ["50", "52", "51"],
        reports: [
          "boxes_minus",
          "top_artists",
          "full_cat",
          "artists",
          "top_artists",
          "photo_lp",
          "lp_no_keys",
          "photo_1c_copies",
          "add_copies",
        ],
      },

      admin: {
        orders: true,
        cashbox: true,
        promocode_messages: true,
        shop_visits: true,
        oracle: true,
        oracle_reports: true,
        modules: true,
        pages: true,
        users_export: true,
        reports: [
          "preorders",
          "emails_qty",
          "emails_stat",
          "special",
          "sales",
          "orders",
          "cd_copies",
          "full_cat",
          "boxes_minus",
          "markets",
          "checks",
          "photo_lp",
          "lp_no_keys",
          "photo_1c_copies",
          "logs",
          "store_pickup",
          "product_sale_log",
          "bertus",
          "sales_speed",
        ],
        users: true,
        services: true,
        carts: true,
        seo: true,
        options: true,
        shortUrl: true,
      },

      admin_king: {
        orders: true,
        cashbox: true,
        oracle: true,
        modules: true,
        pages: true,
        reports: true,
        users: true,
        services: true,
        carts: true,
        seo: true,
        options: true,
        oracle_reports: true,
        shortUrl: true,
        users_export: true,
      },

      zakupka: {
        orders: false,
        cashbox: false,
        oracle: true,
        modules: ["lp", "cd", "acc_products"],
        packs: ["50"],
        reports: ["sales", "full_cat", "search", "top_artists", "sales_speed"],
        users: false,
        services: false,
        carts: false,
        seo: false,
        options: false,
      },

      manager: {
        orders: true,
        oracle: true,
        carts: true,
        reports: ["store_pickup", "preorders"],
        shortUrl: true,
      },

      analyst: {
        // packs: true,
        modules: true,
        orders: true,
        oracle: true,
        cashbox: true,
        carts: true,
        reports: true,
        seo: true,
        options: true,
        users: true,
        services: true,
        pages: true,
      },
    },
    dict: {
      orderStatuses: [],
      orderManagers: [],
      paymentTypes: [],
      deliveryTypes: [],
      accCategories: [],
    },
    modules: [],
    menuModules: [],
    pagesTransition: false,
    notifications: [],
  },
  getters: {
    getUserRole: (state) => () => {
      return state.userRole
    },
    getUserId: (state) => () => {
      return state.userId
    },
    getUserRolePermissions: (state) => () => {
      if (state.userRole != "") return state.userRolePermissions[state.userRole]
      else return {}
    },
    getParams: (state) => () => {
      return state.params
    },
    getDict: (state) => () => {
      return state.dict
    },
    getNotifications: (state) => () => {
      return state.notifications
    },
    getModules: (state) => () => {
      return state.modules
    },
    getModuleById: (state) => (id) => {
      return state.modules.find((item) => {
        return item.module_id == id
      })
    },
    getMenuModules: (state) => () => {
      return state.menuModules
    },
    getPagesTransition: (state) => () => {
      return state.pagesTransition
    },
    getOrderStatuses: (state) => () => {
      return state.dict.orderStatuses
    },
    getOrderManagers: (state) => () => {
      return state.dict.orderManagers
    },
    getPaymentTypes: (state) => () => {
      return state.dict.paymentTypes
    },
    getDeliveryTypes: (state) => () => {
      return state.dict.deliveryTypes
    },
    getAccCategories: (state) => () => {
      return state.dict.accCategories
    },
    // getArtistById: (state) => (id) => {
    //   return state.artists2.find((item) => {
    //     return item.id == id
    //   })
    // },
  },
  mutations: {
    SET_MODULES_LIST(state, data) {
      state.menuModules = data.menuItems
      state.modules = data.modules
    },
    SET_ORDER_STATUSES(state, data) {
      state.dict.orderStatuses = data
    },
    SET_NOTIFICATIONS(state, data) {
      state.notifications = data
    },
    SET_ORDER_MANAGERS(state, data) {
      state.dict.orderManagers = data
    },
    SET_PAYMENT_TYPES(state, data) {
      state.dict.paymentTypes = data
    },
    SET_DELIVERY_TYPES(state, data) {
      state.dict.deliveryTypes = data
    },
    SET_ACC_CATEGORIES(state, data) {
      state.dict.accCategories = data
    },
    SET_PARAMS(state, p) {
      state.params = p
    },
    SET_USER_ROLE(state, p) {
      state.userRole = p
    },
    SET_USER_ID(state, p) {
      state.userId = p
    },
    SET_TRANSITION(state, val) {
      state.pagesTransition = val
    },
  },
  actions: {
    setModulesList({ commit }, newValue) {
      commit("SET_MODULES_LIST", newValue)
    },
    setOrderStatuses({ commit }, newValue) {
      commit("SET_ORDER_STATUSES", newValue)
    },
    setNotifications({ commit }, newValue) {
      commit("SET_NOTIFICATIONS", newValue)
    },
    setOrderManagers({ commit }, newValue) {
      commit("SET_ORDER_MANAGERS", newValue)
    },
    setPaymentTypes({ commit }, newValue) {
      commit("SET_PAYMENT_TYPES", newValue)
    },
    setDeliveryTypes({ commit }, newValue) {
      commit("SET_DELIVERY_TYPES", newValue)
    },
    setAccCategories({ commit }, newValue) {
      commit("SET_ACC_CATEGORIES", newValue)
    },
    setParams({ commit }, newValue) {
      commit("SET_PARAMS", newValue)
    },
    setUserRole({ commit }, newValue) {
      commit("SET_USER_ROLE", newValue)
    },
    setUserId({ commit }, newValue) {
      commit("SET_USER_ID", newValue)
    },
    setPagesTransition({ commit }, newValue) {
      commit("SET_TRANSITION", newValue)
    },
  },
  modules: {},
})
